var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_login"},[_c('div',{staticClass:"tips"},[_vm._v("请用公司邮箱登录进行相关操作")]),_c('div',{staticClass:"btn",on:{"click":_vm.loginLayerShowClick}},[_vm._v("立即登录")])])
}
var staticRenderFns = []

export { render, staticRenderFns }